import FormTextField from "../FormTextField/FormTextField.component";
import React from "react";
import { InputText } from "primereact/inputtext";
import './FormPhoneNumberField.scss'
import configVM from "../../../ViewModel/ConfigVM";

class FormPhoneNumberField extends FormTextField {

    onValidate(): boolean {
        const ret = super.onValidate();
        if (!ret) {
            return ret;
        }
        if (!this.props.value) return !this.props.required;
        return this.validatePhoneNUmber(this.props.value);
    }
    validatePhoneNUmber = (val?: any): boolean => {
        return ((val).length === 9) && (val.substr(0, 2) === '78' || val.substr(0, 2) === '77' || val.substr(0, 2) === '79');
    };

    render() {
        return (
            <div className={this.props.className} id={this.props.id}>
                <div className="p-inputgroup p-float-label phone-field-addon">
                    <span className="p-inputgroup-addon phone-filed-flag">
                        {configVM.countryCode}
                    </span>
                    <InputText maxLength={this.props.maxLength} keyfilter={this.props.filter} name={this.props.name}
                        className="input-text" type={this.props.type} value={this.props.value} onChange={this.props.onChange}
                        onBlur={this.onBlur} required={(this.props.required === undefined) ? true : this.props.required}
                        onFocus={this.props.onFocus} />
                    <label className="label-name phone-field">{this.props.label}</label>
                </div>

                {this.state.errorMsg &&
                    <div className="error-container">
                        <p className="error-message">
                            {this.state.errorMsg}
                        </p>
                    </div>
                }
            </div>
        )
    }
}

export default FormPhoneNumberField;